import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'
import InputLabel from '@material-ui/core/InputLabel'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { withApi } from '~shared/api/ApiContext'
import { insertBetween } from '~shared/utils'
import CustomMenuField from '~components/atom/FieldFactory/CustomMenuField'

const styles = () => ({
  root: {},
  nestedRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  select: {
    paddingTop: 0,
    paddingBottom: 0,
    minHeight: 34,
  },
  condition: {
    width: '100%',
    margin: 0,
    borderRadius: 5,
    border: '1px solid rgba(0,0,0,0.1)',
  },
  nestedCondition: {
    padding: 10,
    margin: 10,
    boxSizing: 'border-box',
  },
  and: {
    margin: `4px 0`,
  },
  addButton: {
    marginTop: 5,
    flexGrow: 0,
    alignSelf: 'flex-start',
  },
})

class ConditionsBlocks extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  _getConditionByIndex = index => {
    const { value: query } = this.props
    return query[index]
  }

  _updateCondition = (index, data) => {
    const { value: query } = this.props

    let condition = this._getConditionByIndex(index)

    const newQuery = [...query]
    condition = { ...condition, ...data }
    newQuery[index] = condition

    const { onChange } = this.props

    onChange({
      target: {
        value: newQuery,
        name: this.props.name,
      },
    })
  }

  handleNestedValueChange = index => e => {
    const { value, typeQuery, isDeleted } = e.target
    const { blockFieldName = 'query' } = this.props

    const condition = this._getConditionByIndex(index)
    const { type } = condition

    if (type !== 'block') return

    if (isDeleted) {
      return this.handleRemoveCondition(index)()
    }

    const newQuery = { ...condition }
    if (typeQuery) newQuery.typeQuery = typeQuery
    if (value) newQuery[blockFieldName] = value

    this._updateCondition(index, newQuery)
  }

  handleChangeTypeQuery = e => {
    const { value: typeQuery } = e.target

    const { onChange, isNested } = this.props

    if (!isNested) return

    onChange({
      target: {
        typeQuery,
      },
    })
  }

  handleRemoveBlock = () => {
    const { isNested, onChange } = this.props

    if (!isNested) return

    onChange({
      target: {
        isDeleted: true,
      },
    })
  }

  handleRemoveCondition = index => () => {
    const { value: query, onChange } = this.props

    const newQuery = [...query]
    newQuery.splice(index, 1)

    onChange({
      target: {
        value: newQuery,
        name: this.props.name,
      },
    })
  }

  handleAddCondition = () => {
    const { value: query, onChange } = this.props

    const newQuery = [...query, {}]

    onChange({
      target: {
        value: newQuery,
        name: this.props.name,
      },
    })
  }

  handleAddBlock = () => {
    const { value: query, onChange, blockFieldName = 'query' } = this.props

    const newQuery = [...query, { type: 'block', typeQuery: 'and', [blockFieldName]: [] }]

    onChange({
      target: {
        value: newQuery,
        name: this.props.name,
      },
    })
  }

  render() {
    let {
      classes,
      className,
      value = [{}],
      label,
      typeQuery = 'AND',
      renderValue,
      disabled: queryDisabled,
      isNested,
      NestedComponent,
      blockFieldName = 'query',
      withoutTypeQuery,
      withoutBlocks,
    } = this.props

    if (!value) value = [{}]
    if (!Array.isArray(value)) value = [value || {}]

    return (
      <div
        className={classNames(classes.root, className, {
          [classes.nestedRoot]: isNested,
        })}
      >
        {isNested && (
          <Grid container item xs={12} direction="row" justify="space-between">
            {!withoutTypeQuery && (
              <Grid item xs={4}>
                <CustomMenuField
                  value={typeQuery}
                  label={'Type of query'}
                  options={[
                    {
                      value: 'and',
                      label: 'AND',
                    },
                    {
                      value: 'or',
                      label: 'OR',
                    },
                  ]}
                  onChange={this.handleChangeTypeQuery}
                />
              </Grid>
            )}
            <IconButton onClick={this.handleRemoveBlock}>
              <Icon>delete</Icon>
            </IconButton>
          </Grid>
        )}

        <InputLabel style={{ position: 'inherit' }} shrink>
          {label}
        </InputLabel>
        {insertBetween(
          value.map((item, i) => {
            const { type } = item

            if (type === 'block') {
              return (
                <Grid
                  spacing={16}
                  alignItems={'center'}
                  className={classNames(classes.condition, classes.nestedCondition)}
                  key={`condition_${i}`}
                >
                  <NestedComponent
                    key={`block_${i}`}
                    {...this.props}
                    {...item}
                    label={null}
                    value={item[blockFieldName]}
                    onChange={this.handleNestedValueChange(i)}
                    isNested
                  />
                </Grid>
              )
            }

            return renderValue(item, i)
          }),
          i => (
            <Typography key={`and_${i}`} className={classes.and}>
              <b>{typeQuery.toUpperCase()}</b>
            </Typography>
          ),
        )}

        {!queryDisabled && (
          <>
            <br />
            <Button
              className={classes.addButton}
              variant={'outlined'}
              onClick={this.handleAddCondition}
            >
              Add Condition
            </Button>
            {!isNested && !withoutBlocks && (
              <Button
                className={classes.addButton}
                variant={'outlined'}
                style={{ marginLeft: '5px' }}
                onClick={this.handleAddBlock}
              >
                Add Block
              </Button>
            )}
          </>
        )}
      </div>
    )
  }
}

export default withApi(withStyles(styles)(ConditionsBlocks))
